import"./ProductList.css.ts.vanilla.css";var d="dd6dj31",r="dd6dj30";export{d as productImage,r as productList};
